export default __webpack_public_path__ + "static/media/Group9242.feefbadc.svg";